import type { IVRInfo } from "../sales-context/SalesContext.types";

// IVR sets the ENABLE_VMP_SALES Connect contact attribute to "1" on calls that should be offered VMP.
// ivrInfo comes only from the voice contact, so this is false on chat by design: VMP-by-flag is voice-only.
export function isVmpSalesEnabled(ivrInfo: IVRInfo | undefined): boolean {
    return ivrInfo?.enableVmpSales === "1";
}
